<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div>
              <!-- <span class="loading-request" v-show="loading"></span> -->
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
              >
                <h1 class="h2">Relatório de Consumo Parcial</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                  <div
                    class="btn-group btn-group-sm"
                    role="group"
                    aria-label="Menu dos Consumo"
                  ></div>
                </div>
              </div>
              <div
                id="alert"
                class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
                :class="alert.color"
                role="alert"
                v-if="alert.message"
              >
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="alert.message = ''"
                ></button>
                <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
                ><br />
                {{ alert.reason }}
              </div>
              <div>
                <div class="float-left">
                  <div class="dropdown">
                    <button
                      class="btn btn-sm btn-primary dropdown-toggle"
                      type="button"
                      id="actionsDDButton"
                      :disabled="invoiceIds.length < 1"
                      :title="
                        invoiceIds.length < 1
                          ? 'Necessário selecionar mais de 1 fatura'
                          : 'Selecione uma ação para executar nas faturas selecionadas'
                      "
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fal fa-cog"></i> Ações
                    </button>
                    <div class="dropdown-menu" aria-labelledby="actionsDDButton">
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent.stop="deleteMultipleInvoices()"
                        ><i class="fal fa-trash m--font-metal"></i> Excluir</a
                      >
                    </div>
                    <button
                      class="btn btn-sm btn-primary ml-2"
                      type="button"
                      id="actionDownloadList"
                      @click="download()"
                    >
                      {{ downloading ? 'Baixando...' : 'Baixar Planilha' }}
                    </button>
                  </div>
                </div>

                <div class="page-amounts">
                  <nav aria-label="...">
                    <ul class="pagination pagination-md">
                      <li class="page-item" :class="{ selected: amount == 3 }">
                        <a @click.prevent.stop="setAmountPerPage(3)" class="page-link paginate"
                          >3</a
                        >
                      </li>
                      <li class="page-item" :class="{ selected: amount == 10 }">
                        <a @click.prevent.stop="setAmountPerPage(10)" class="page-link paginate"
                          >10</a
                        >
                      </li>
                      <li class="page-item" :class="{ selected: amount == 50 }">
                        <a @click.prevent.stop="setAmountPerPage(50)" class="page-link paginate"
                          >50</a
                        >
                      </li>
                      <li class="page-item" :class="{ selected: amount == 100 }">
                        <a @click.prevent.stop="setAmountPerPage(100)" class="page-link paginate"
                          >100</a
                        >
                      </li>
                      <li class="page-item" :class="{ selected: amount == 150 }">
                        <a @click.prevent.stop="setAmountPerPage(150)" class="page-link paginate"
                          >150</a
                        >
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              <div class="paginator-info-top m-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
            </div>
            <div class="table-responsive">
              <div class="container-table">
                <table class="table table-striped- table-bordered table-hover table-checkable">
                  <thead>
                    <tr>
                      <td class="text-center align-middle" width="20">
                        <label
                          class="m-checkbox m-checkbox--single m-checkbox--solid m-checkbox--brand mb-0 mt-0"
                          v-b-tooltip.hover
                          title="Selecionar todas faturas dessa página"
                        >
                          <input
                            type="checkbox"
                            @click="selectAllReport"
                            v-model="allSelected"
                            class="m-group-checkable"
                          />
                          <span></span>
                        </label>
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="70"
                        :class="{ 'table-sorted': sortType == 'id' }"
                        @click="sortCall('id')"
                      >
                        ID Cliente
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'co_id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'co_id' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'co_id'"></span>
                      </td>
                      <td nowrap class="text-center align-middle pointer" width="100">Cliente</td>
                      <td nowrap class="text-center align-middle pointer" width="100">CNPJ/CPF</td>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="60"
                        :class="{ 'table-sorted': sortType == 'billing_month' }"
                        @click="sortCall('billing_month')"
                      >
                        Data de geração
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'billing_month' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'billing_month' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'billing_month'"></span>
                      </td>

                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="100"
                        :class="{ 'table-sorted': sortType == 'price_total' }"
                        @click="sortCall('price_total')"
                      >
                        Valor
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'price_total' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'price_total' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'price_total'"></span>
                      </td>
                      <td nowrap class="text-center align-middle" width="20">Tipo</td>
                      <td nowrap class="text-center align-middle" width="20">Produto</td>

                      <td nowrap class="text-center align-middle" width="20">Ações</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td></td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueNumber"
                          @input="callData"
                          v-model="filters.id"
                          v-b-tooltip.hover
                          title="Filtrar por ID do Cliente"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.name"
                          v-b-tooltip.hover
                          title="Filtrar por nome do Cliente"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.document"
                          v-b-tooltip.hover
                          title="Filtrar por CNPJ/CPF"
                        />
                      </td>
                      <td>
                        <SelectInvoiceBillingMonth
                          :selected="filters.month"
                          partialInvoice="1"
                          @change="setFilter('month', $event)"
                          class="form-control-sm"
                          v-b-tooltip.hover
                          title="Filtrar por mês de cobrança"
                        />
                      </td>

                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueFloat"
                          @input="callData"
                          v-model="filters.price"
                          v-b-tooltip.hover
                          title="Filtrar por valor total"
                        />
                      </td>
                      <td>
                        <SelectInvoiceTypes
                          :selected="filters.type"
                          @change="setFilter('type', $event)"
                          class="form-control-sm"
                          v-b-tooltip.hover
                          title="Filtrar por tipo"
                        />
                      </td>
                      <td>
                        <SelectProducts
                          :selected="filters.products"
                          @change="setFilter('product', $event)"
                          class="form-control-sm"
                          v-b-tooltip.hover
                          title="Filtrar por Produtos"
                        />
                      </td>

                      <td class="text-center align-middle" nowrap>
                        <button
                          type="button"
                          class="btn btn-outline-brand btn-sm btn-outline-metal btn-filter mr-1"
                          @click="callData"
                          v-b-tooltip.hover
                          title="Clique para filtrar"
                        >
                          <i class="far fa-search"></i> Filtrar
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-brand btn-sm btn-outline-metal btn-filter"
                          @click="clearFilters"
                          v-b-tooltip.hover
                          title="Clique para limpar os filtros"
                        >
                          <i class="far fa-eraser"></i> Limpar
                        </button>
                      </td>
                    </tr>
                    <tr v-for="(invoice, id) in data.data" :key="id">
                      <td class="text-center align-middle" width="60">
                        <label
                          class="m-checkbox m-checkbox--single m-checkbox--solid m-checkbox--brand mb-0 mt-0"
                          v-b-tooltip.hover.right.title="`#${invoice.id} - Selecionar essa fatura`"
                        >
                          <input
                            type="checkbox"
                            v-model="invoiceIds"
                            @click="select"
                            :value="invoice.id"
                            class="m-group-checkable"
                          />
                          <span></span>
                        </label>
                      </td>
                      <td class="text-center align-middle">
                        {{ invoice.company ? invoice.company.id : invoice.customer.id }}
                      </td>
                      <td class="text-left align-middle">
                        {{
                          invoice.company
                            ? invoice.company.name
                            : invoice.customer.customerable.co_name
                            ? invoice.customer.customerable.co_name
                            : invoice.customer.customerable.name
                        }}
                      </td>
                      <td class="text-left align-middle">
                        {{
                          invoice.company
                            ? invoice.company.cnpj
                            : (invoice.customer.documents.value
                                ? invoice.customer.documents.value
                                : '-')
                              | cnpj
                              | cpf
                        }}
                      </td>
                      <td class="text-center align-middle">{{ invoice.created_at | date }}</td>

                      <td class="text-right align-middle">
                        {{
                          invoice.discount > invoice.price_total + invoice.price_extra
                            ? 0
                            : (invoice.price_total + invoice.price_extra - invoice.discount) | money
                        }}
                      </td>
                      <td class="text-center align-middle">
                        <span
                          class="m--font-gray"
                          v-if="invoice.contr_id"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Fatura Recorrente"
                          ><i class="fas fa-copy"></i
                        ></span>
                        <span
                          class="m--font-brand"
                          v-else
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Fatura Avulsa"
                          ><i class="fas fa-file"></i
                        ></span>
                      </td>
                      <td class="text-center align-middle">
                        {{ invoice.product.name }}
                      </td>

                      <td nowrap class="text-center align-middle">
                        <router-link
                          v-if="invoice.co_id"
                          tag="a"
                          :to="`/reports/invoice/company/${invoice.co_id}/${$options.filters.month(
                            invoice.billing_month
                          )}`"
                          class="icon-circle"
                          v-b-tooltip.hover
                          title="Ver relatório de consumo deste Cliente"
                        >
                          <i class="fas fa-file-invoice-dollar"></i>
                        </router-link>
                        <router-link
                          v-if="!invoice.co_id && invoice.customer_id"
                          tag="a"
                          :to="`/reports/invoice/customer/${invoice.customer_id}/${invoice.id}`"
                          class="icon-circle"
                          v-b-tooltip.hover
                          title="Ver relatório de consumo deste Cliente"
                        >
                          <i class="fas fa-file-invoice-dollar"></i>
                        </router-link>

                        <a
                          href
                          @click.prevent.stop="
                            downloadInvoice(
                              invoice.id,
                              invoice.customer_id ? invoice.customer_id : 0,
                              id
                            )
                          "
                          class="icon-circle"
                          v-b-tooltip.hover
                          title="Baixar fatura"
                        >
                          <b-spinner
                            style="vertical-align: baseline; margin-top: 2px"
                            small
                            label="Spinning"
                            v-if="(loadingDownload = true && id == indexDownload)"
                          ></b-spinner>
                          <i v-else class="fas fa-download"></i>
                        </a>
                        <a
                          href=""
                          @click.prevent.stop="confirmDel(invoice.id)"
                          class="icon-circle"
                          :class="{ disabled: invoice.status > 0 }"
                          v-b-tooltip.hover
                          title="Excluir fatura"
                        >
                          <i class="fas fa-trash"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a class="page-link paginate" @click.prevent.stop="page = 1"
                        ><i class="fal fa-angle-double-left"></i
                      ></a>
                    </li>
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page - 1"
                        ><i class="fal fa-angle-left"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page - 2"
                      >
                        {{ data.current_page - 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page - 1"
                      >
                        {{ data.current_page - 1 }}</a
                      >
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate"> {{ data.current_page }} </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page + 1"
                      >
                        {{ data.current_page + 1 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page + 1 == data.last_page }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page + 2"
                      >
                        {{ data.current_page + 2 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page + 1"
                        ><i class="fal fa-angle-right"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a class="page-link paginate" @click.prevent.stop="page = data.last_page"
                        ><i class="fal fa-angle-double-right"></i
                      ></a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
    </div>
    <transition name="slideleft" mode="out-in">
      <InvoiceLooseModal v-if="showInvoiceLoose" @updateList="callData" />
    </transition>
    <transition name="slideleft" mode="out-in">
      <InvoiceModal v-if="showInvoiceSave" @updateList="callData" />
    </transition>
    <transition name="fade" mode="out-in">
      <div
        class="m-quick-sidebar-overlay"
        v-if="showInvoiceLoose"
        @click="closeInvoiceLoose()"
      ></div>
    </transition>
    <transition name="fade" mode="out-in">
      <div class="m-quick-sidebar-overlay" v-if="showInvoiceSave" @click="closeSaveInvoice()"></div>
    </transition>
    <GenerateSalePerGroup></GenerateSalePerGroup>
  </div>
</template>

<script>
import InvoiceModal from '@/components/invoices/InvoiceModal';
import InvoiceLooseModal from '@/components/invoices/InvoiceLooseModal';
import SelectInvoiceBillingMonth from '@/components/forms/SelectInvoiceBillingMonth';
import SelectInvoiceStatuses from '@/components/forms/SelectInvoiceStatuses';
import SelectInvoiceTypes from '@/components/forms/SelectInvoiceTypes';
import SelectProducts from '@/components/forms/SelectProducts';
import GenerateSalePerGroup from '@/components/invoices/GenerateSalePerGroup';
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';
import { validationFilterValueMixin } from '@/mixins/validationFilterValueMixin.js';

import { baseApiUrl, externalApiUrl, XAPIKey } from '@/global';

import axios from 'axios';

export default {
  mixins: [returnMessageMixin, validationFilterValueMixin],
  name: 'Invoices',
  components: {
    InvoiceModal,
    InvoiceLooseModal,
    SelectInvoiceBillingMonth,
    SelectInvoiceStatuses,
    SelectInvoiceTypes,
    SelectProducts,
    GenerateSalePerGroup,
  },
  data() {
    return {
      indexDownload: -1,
      downloading: false,
      loadingDownload: false,
      sortType: localStorage.invoicesSortType ? localStorage.invoicesSortType : 'billing_month',
      sortReverse: localStorage.invoicesSortReverse ? localStorage.invoicesSortReverse : false,
      amount: localStorage.invoicesDataAmount ? localStorage.invoicesDataAmount : 50,
      page: localStorage.invoicesDataPage ? localStorage.invoicesDataPage : 1,
      filters: {
        id: localStorage.invoicesFilterId ? localStorage.invoicesFilterId : '',
        name: localStorage.invoicesFilterName ? localStorage.invoicesFilterName : '',
        document: localStorage.invoicesDocumentName ? localStorage.invoicesDocumentName : '',
        group: localStorage.invoicesFilterGroup ? localStorage.invoicesFilterGroup : '',
        month: localStorage.singleInvoicesFilterMonth ? localStorage.singleInvoicesFilterMonth : '',
        price: localStorage.invoicesFilterPrice ? localStorage.invoicesFilterPrice : '',
        type: localStorage.invoicesFilterType ? localStorage.invoicesFilterType : -1,
        status: localStorage.invoicesFilterStatus ? localStorage.invoicesFilterStatus : -1,
      },
      data: [],
      dialog: '',
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      selected: [],
      allSelected: false,
      invoiceIds: [],
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showInvoiceLoose() {
      return this.$store.state.showInvoiceLoose;
    },
    showInvoiceSave() {
      return this.$store.state.showInvoiceSave;
    },
  },
  methods: {
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
      this.callData();
    },
    clearFilters() {
      this.filters.id = '';
      this.filters.name = '';
      this.filters.document = '';
      this.filters.group = '';
      this.filters.month = '';
      this.filters.price = '';
      (this.filters.product = ''), (this.filters.type = -1);
      this.filters.status = -1;
      this.filters.sortType = 'billing_month';
      this.filters.sortReverse = false;
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('invoicesFilterId', this.filters.id);
      localStorage.setItem('invoicesFilterName', this.filters.name);
      localStorage.setItem('invoicesDocumentName', this.filters.document);
      localStorage.setItem('invoicesFilterGroup', this.filters.group);
      localStorage.setItem('singleInvoicesFilterMonth', this.filters.month);
      localStorage.setItem('invoicesFilterPrice', this.filters.price);
      localStorage.setItem('invoicesFilterProduct', this.filters.product);
      localStorage.setItem('invoicesFilterType', this.filters.type);
      localStorage.setItem('invoicesFilterStatus', this.filters.status);
      localStorage.setItem('invoicesDataAmount', this.amount);
      localStorage.setItem('invoicesDataPage', this.page);
      localStorage.setItem('invoicesSortType', this.sortType);
      localStorage.setItem('invoicesSortReverse', this.sortReverse);
    },
    convertFilters() {
      return `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&name=${this.filters.name ? this.filters.name : ''}&document=${
        this.filters.document ? this.filters.document : ''
      }&group=${this.filters.group ? this.filters.group : ''}&month=${
        this.filters.month ? this.filters.month : ''
      }&price=${this.filters.price ? this.filters.price : ''}&type=${
        this.filters.type ? this.filters.type : -1
      }&product=${this.filters.product ? this.filters.product : ''}&status=${
        this.filters.status ? this.filters.status : -1
      }&amount=${this.amount}&sortType=${this.sortType}&sortOrder=${
        this.sortReverse ? 'DESC' : 'ASC'
      }&isPartialInvoice=1`;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType == sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      const timeWindow = 700;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.data.current_page = null;
        this.invoiceIds = [];
        if (this.allSelected) {
          this.selectAllReport();
        }
        this.setStorageFilters();
        this.getDatas();
      }, timeWindow);
    },
    getIconProducts({ icon }) {
      if (icon) {
        return require(`@/assets/media/img/icons/${icon}.svg`);
      }
    },
    downloadInvoiceLegacy(id, customerId) {
      const url = `${baseApiUrl}/v1/invoice/download/${id}?customerId=${customerId}`;
      axios({
        url,
        responseType: 'arraybuffer',
      }).then((res) => {
        this.downloadFile(res, 'customFilename');
      });
    },
    downloadInvoice(id, customerId, indexDownload) {
      this.indexDownload = indexDownload;
      this.loadingDownload = true;

      const urlHost = `${window.location.protocol}//${window.location.host}`;
      const token = axios.defaults.headers.common.Authorization;

      const urlGriffinInvoice = `${urlHost}/reports/invoice/customer/${customerId}/${id}`;

      // Caso de teste
      const url = `${baseApiUrl}/v1/invoice/download/${id}?token=${token}&url=${urlGriffinInvoice}`;

      axios(url)
        .then((res) => {
          this.downloadFile(res.data, 'customFilename');

          this.indexDownload = -1;
          this.loadingDownload = false;
        })
        .catch((error) => {
          this.logMessageFailed(error.response);

          this.indexDownload = -1;
          this.loadingDownload = false;
        });
    },
    downloadFile(response, filename) {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      const newBlob = new Blob([response.data], { type: 'application/pdf' });

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      //  const data = window.URL.createObjectURL(newBlob);
      const data = `data:application/pdf;base64,${response}`;
      const link = document.createElement('a');
      link.href = data;
      link.download = `${filename}.pdf`;
      link.click();
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/invoice/search/${this.convertFilters()}`;
      axios(url).then((res) => {
        this.data = res.data;
        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },

    download() {
      this.downloading = true;
      const url = `${baseApiUrl}/v1/invoice/download-report-parcial/${this.convertFilters()}`;
      axios(url)
        .then((res) => {
          const arrData = res.data;

          let csvContent = 'data:text/csv;charset=utf-8,';
          csvContent += [
            Object.keys(arrData[0]).join(';'),
            ...arrData.map((item) => String(Object.values(item).join(';'))),
          ]
            .join('\n')
            .replace(/(^\[)|(\]$)/gm, '');

          const data = encodeURI(csvContent);
          const link = document.createElement('a');

          link.setAttribute('href', data);

          let fileName = `faturas_parciais`;

          if (this.start) {
            fileName += `_${this.start}-${this.finish}`;
          }

          fileName = `${fileName}.csv`;

          link.setAttribute('download', fileName);

          link.click();
          this.downloading = false;
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
          this.downloading = false;
        });
    },
    changeStatus(invoice) {
      const data = {
        id: invoice.id,
        status: invoice.activated_at ? 0 : 1,
      };
      const url = `${baseApiUrl}/v1/invoice/status`;
      axios.post(url, data);
    },
    confirmDel(id) {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja excluir essa fatura?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: 'Confirmar exclusão',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value == true) {
            this.del(id);
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> A fatura não foi excluída!',
              {
                theme: 'toasted-primary',
                type: 'info',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    confirmDeleteMultiples() {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja excluir todas as faturas selecionadas?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: 'Confirmar exclusão',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.deleteMultiples(this.invoiceIds);
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> As faturas não foram excluídas!',
              {
                theme: 'toasted-primary',
                type: 'info',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    confirmChangeMultipleInvoiceStatus(status) {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm(
          'Tem certeza que deseja alterar o status de todas as faturas selecionadas?',
          {
            size: 'md',
            contentClass: 'p-3',
            bodyClass: 'modal-body-fix',
            buttonSize: 'md',
            okVariant: 'success',
            okTitle: 'Confirmar Alteração',
            cancelTitle: 'Cancelar',
            cancelVariant: 'metal',
            footerClass: 'p-4',
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          if (value === true) {
            this.changeMultipleStatus(this.invoiceIds, status);
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> As faturas não foram alteradas!',
              {
                theme: 'toasted-primary',
                type: 'info',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    confirmGenerateSale() {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Gerar venda para todas as faturas selecionadas?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'success',
          okTitle: 'Gerar venda',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.generateSale(this.invoiceIds);
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> As vendas não foram geradas',
              {
                theme: 'toasted-primary',
                type: 'info',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    confirmSendERP() {
      if (this.invoiceIds.length <= 0) {
        this.$toasted.show(
          '<i class="fas fa-exclamation-triangle"></i> Selecione ao menos uma fatura',
          {
            theme: 'toasted-primary',
            type: 'alert',
            position: 'top-right',
            duration: 5000,
          }
        );
        return;
      }
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Deseja enviar as faturas selecionadas para o ERP?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'success',
          okTitle: 'Faturar',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.sendInvoiceERP(this.invoiceIds);
          } else {
            this.$toasted.show('<i class="fas fa-exclamation-triangle"></i> Faturas não enviadas', {
              theme: 'toasted-primary',
              type: 'info',
              position: 'top-right',
              duration: 5000,
            });
          }
        });
    },
    del(id) {
      const url = `${baseApiUrl}/v1/invoice/delete/${id}`;
      axios(url)
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    deleteMultiples(ids) {
      const url = `${baseApiUrl}/v1/invoice/delete-multiple`;
      axios
        .delete(url, { data: { ids } })
        .then((res) => {
          this.logMessage(res);
          this.callData();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    changeMultipleStatus(ids, status) {
      const url = `${baseApiUrl}/v1/invoice/change-status`;
      axios
        .put(url, { id: ids, status })
        .then((res) => {
          this.logMessage(res);
          this.callData();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    openInvoiceLoose(id) {
      this.$store.state.showInvoiceLoose = id;
    },
    openSaveInvoice(id) {
      this.$store.state.showInvoiceSave = id;
    },
    closeInvoiceLoose() {
      this.$store.state.showInvoiceLoose = null;
      this.callData();
    },
    closeSaveInvoice() {
      this.$store.state.showInvoiceSave = null;
      this.callData();
    },
    selectAllReport() {
      this.invoiceIds = [];
      this.allSelected = !this.allSelected;
      if (this.allSelected) {
        const { data: invoices } = this.data;
        invoices.forEach((invoice) => {
          this.invoiceIds.push(invoice.id);
        });
      }
    },
    select() {
      this.allSelected = false;
    },
    deleteMultipleInvoices() {
      if (this.invoiceIds.length > 0) {
        this.confirmDeleteMultiples();
      }
    },
    changeMultipleInvoiceStatus(status) {
      if (this.invoiceIds.length > 0) {
        this.confirmChangeMultipleInvoiceStatus(status);
      }
    },
    generateInvoiceSale() {
      if (this.invoiceIds.length <= 0) {
        this.$toasted.show(
          '<i class="fas fa-exclamation-triangle"></i> Selecione ao menos uma fatura',
          {
            theme: 'toasted-primary',
            type: 'alert',
            position: 'top-right',
            duration: 5000,
          }
        );
        return;
      }
      this.confirmGenerateSale();
    },
    setAmountPerPage(amount) {
      this.amount = amount;
    },
    generateSale(ids) {
      const url = `${baseApiUrl}/v1/invoice/generate-sale`;
      axios
        .post(url, { ids })
        .then((res) => {
          this.logMessage(res);
          this.callData();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    sendInvoiceERP(ids) {
      const url = `${baseApiUrl}/v1/invoice/generate-sale-erp`;
      axios
        .post(url, { ids })
        .then((res) => {
          this.logMessage(res);
          this.callData();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    confirmSendEmails() {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Confirma o envio de email para todas as faturas selecionadas?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'success',
          okTitle: 'Enviar',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.sendEmails(this.invoiceIds);
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> Emails não foram enviados',
              {
                theme: 'toasted-primary',
                type: 'info',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    sendEmails(ids) {
      const url = `${baseApiUrl}/v1/invoice/send-emails`;
      axios
        .post(url, { ids })
        .then((res) => {
          this.invoiceIds = [];
          this.logMessage(res);
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    sendInvoiceIugu(ids) {
      const url = `${baseApiUrl}/v1/invoice/generate-sale-iugu`;
      axios
        .post(url, { ids })
        .then((res) => {
          this.logMessage(res);
          this.callData();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    confirmSendIugu() {
      if (this.invoiceIds.length <= 0) {
        this.$toasted.show(
          '<i class="fas fa-exclamation-triangle"></i> Selecione ao menos uma fatura',
          {
            theme: 'toasted-primary',
            type: 'alert',
            position: 'top-right',
            duration: 5000,
          }
        );
        return;
      }
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Deseja enviar as faturas selecionadas para o Iugu?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'success',
          okTitle: 'Faturar',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.sendInvoiceIugu(this.invoiceIds);
          } else {
            this.$toasted.show('<i class="fas fa-exclamation-triangle"></i> Faturas não enviadas', {
              theme: 'toasted-primary',
              type: 'info',
              position: 'top-right',
              duration: 5000,
            });
          }
        });
    },
    confirmCancelInvoices() {
      if (this.invoiceIds.length <= 0) {
        this.$toasted.show(
          '<i class="fas fa-exclamation-triangle"></i> Selecione ao menos uma fatura',
          {
            theme: 'toasted-primary',
            type: 'alert',
            position: 'top-right',
            duration: 5000,
          }
        );
        return;
      }
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Deseja cancelar as faturas selecionadas?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'success',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.cancelInvoice(this.invoiceIds);
          } else {
            this.$toasted.show('<i class="fas fa-exclamation-triangle"></i> Ação não realizada', {
              theme: 'toasted-primary',
              type: 'info',
              position: 'top-right',
              duration: 5000,
            });
          }
        });
    },
    cancelInvoice(ids) {
      const url = `${baseApiUrl}/v1/invoice/cancel`;
      axios
        .post(url, { ids })
        .then((res) => {
          this.logMessage(res);
          this.callData();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
  },
  watch: {
    amount() {
      if (this.page == 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    this.getDatas();
    window.scroll(0, 0);
  },
};
</script>
